var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.064 15.552c.395 0 .72.396.72.9s-.306.9-.702.9H.918c-.396 0-.72-.396-.72-.9s.324-.9.72-.9h16.146zM11.014.666c.325 0 .588.263.588.587v5.172h2.688c.232 0 .448.139.541.355a.623.623 0 01-.076.633l-5.346 5.871a.576.576 0 01-.433.201.557.557 0 01-.433-.185L2.934 7.43a.597.597 0 01-.124-.649.591.591 0 01.54-.355h2.998V1.253c0-.325.263-.587.588-.587z"
  })));
}
export default SvgExport;